module.exports = __webpack_public_path__ + "static/media/phoneTitle.87af18ec.png";